const chasingGreatness = {
  slug: "2024-chasing-greatness",
  title: "Chasing Greatness - ECommerce Website",
  category: "ECommerce, UX",
  client: "Hinton Publishing",
  duration: "2 Months",
  cover: "/assets/qJJ7hslHIvchtu1qY2MfQZN5ML0.png",
  summary: "A Shopify rebuild of the Novak Books store as it grew into the Chasing Greatness tennis history series.",
  gallery: [
    "/assets/qJJ7hslHIvchtu1qY2MfQZN5ML0.png",
    "/assets/HNl746YzEQv7JphMq5A5nQJ1Y.webp",
    "/assets/jqztdhjQYDlNkD5Zc15smZQlUk.webp",
  ],
  blocks: [
    {
      type: "link",
      href: "https://2024tennis.com/",
      label: "New Website",
    },
    {
      type: "richText",
      html: `<h4>My Approach</h4>
<p>I set out to make the website simple, inviting, and visually strong without making things complicated. The focus was on good navigation and clear product pages, letting the photography and stories do most of the work. Every choice was about getting people from the home page to checkout as smoothly as possible, while giving them a sense of why these books matter.</p>
<h4>Vision and Innovation</h4>
<p>This redesign was about moving Novak Books from a basic online shop to something that feels more like a modern tennis brand. I used Shopify’s tools to keep things fast and reliable, brought in bold fonts and crisp images, and added subtle animations for a polished feel. The Chasing Greatness series isn’t just a product—it’s part of a bigger story, and the site now reflects that.</p>
<h4>Identifying Unique Challenges</h4>
<p>Going from one-player focus to a series about tennis history meant we had to rethink the navigation and how products are shown. The challenge was to open up the brand to new stories without losing loyal customers. My solution was to build flexible sections that highlight Novak, introduce new players, and make sure returning visitors still feel at home.</p>
<h4>Resolving Complex Problems</h4>
<p>Customizing Shopify let us manage lots of different product versions, handle pre-orders, and set up collections for the new releases. I made sure the checkout was as simple as possible, set up features like inventory tracking and abandoned cart recovery, and organized everything so it’s easy for the team to update as new books come out.</p>
<h4>User-Centric Design</h4>
<p>Everything here is designed for real tennis fans—people who care about the game, the stories, and the details. I kept layouts simple, used lots of high-quality photos, and made sure the site works just as well on your phone as on a computer. There are product recommendations, clear CTAs, and space for excerpts so visitors get a real taste of each edition.</p>
<h4>Meeting User Needs</h4>
<p>As Novak Books moves toward being more than just a single-athlete brand, the new site features:</p>
<ul>
  <li><p><strong>The Collection</strong>: Showcasing every edition in the Chasing Greatness series</p></li><li><p><strong>For Collectors</strong>: Details on limited editions and what makes them special</p></li><li><p><strong>The Vision</strong>: A look at where the brand is headed and why</p></li>
</ul>
<p>The setup is flexible, ready to grow as new players and books join the lineup.</p>
<h4>Conclusion</h4>
<p>This wasn’t just a new coat of paint—it was a total update. By putting the story and the user first, and making the most of Shopify’s tools, Novak Books is now set up as the go-to place for tennis fans who want to collect, celebrate, and remember greatness. The site is more than a shop—it’s a place to experience the legacy.</p>`,
    },
  ],
  relatedSlugs: ["trendless", "animatic-remastered", "seven-due-dates"],
  seo: {
    title: "Chasing Greatness - ECommerce Website — Matia Dosen",
    description: "UX Designer and Creative",
  },
}

export default chasingGreatness
